import { Building2, Users as UsersIcon, Building, TrendingUp, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const BuyerGroups = () => {
  const groups = [
    {
      icon: Building2,
      title: 'Institutionelle Investoren',
      description:
        'Versicherungen, Pensionsfonds und offene Immobilienfonds suchen Core-Objekte mit langfristigen Mietverträgen.',
      link: '/investoren/institutionell'
    },
    {
      icon: UsersIcon,
      title: 'Family Offices',
      description:
        'Vermögende Familien investieren in stabile Handelsimmobilien als langfristige Kapitalanlage.',
      link: '/investoren/family-offices'
    },
    {
      icon: TrendingUp,
      title: 'Privatinvestoren',
      description:
        'Einzelinvestoren mit Fokus auf Rendite und Wertsteigerungspotenzial.',
      link: '/investoren/privatinvestoren'
    },
    {
      icon: Building,
      title: 'Projektentwickler',
      description:
        'Entwickler mit Interesse an Umnutzungen oder Neuentwicklungen auf attraktiven Grundstücken.',
      link: '/investoren/projektentwickler'
    },
  ];

  return (
    <section className="py-24 bg-white" data-testid="buyer-groups-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block">
            <div className="w-16 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-4 mx-auto"></div>
          </div>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4"
            style={{ color: 'var(--navy-900)' }}
          >
            Unsere Käufergruppen
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: 'var(--gray-600)' }}>
            Wir sprechen gezielt die richtigen Käufer für Ihr Objekt an
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {groups.map((group, index) => {
            const IconComponent = group.icon;
            return (
              <div
                key={index}
                className="glass-card flex flex-col gap-6 p-8 hover:shadow-xl transition-all duration-300 border-l-4"
                style={{ borderLeftColor: 'var(--gold-600)' }}
                data-testid={`buyer-group-${index}`}
              >
                <div className="flex items-start gap-6">
                  <div
                    className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md"
                    style={{
                      background: 'linear-gradient(135deg, #0F2744 0%, #2563A0 100%)'
                    }}
                  >
                    <IconComponent className="h-8 w-8 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3
                      className="text-xl font-bold mb-3"
                      style={{ color: 'var(--navy-800)' }}
                    >
                      {group.title}
                    </h3>
                    <p className="text-base leading-relaxed mb-4" style={{ color: 'var(--gray-600)' }}>
                      {group.description}
                    </p>
                  </div>
                </div>
                <Link to={group.link} className="mt-auto">
                  <Button
                    variant="outline"
                    className="w-full font-semibold"
                    style={{
                      borderColor: 'var(--gold-600)',
                      color: 'var(--navy-700)'
                    }}
                  >
                    Mehr erfahren
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};